import { render } from "./PartnersEditor.vue?vue&type=template&id=06974910&scoped=true"
import script from "./PartnersEditor.vue?vue&type=script&lang=js"
export * from "./PartnersEditor.vue?vue&type=script&lang=js"

import "./PartnersEditor.vue?vue&type=style&index=0&id=06974910&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06974910"]])

export default __exports__